import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer";
import date from "../../Assets/Client/Date.png";
import office from "../../Assets/Client/Office.png";
import keys from "../../Assets/Client/Keys.png";
import landingImage4 from "../../Assets/Home/landingImage4.png";
import Navbar from "../../Components/Navbar";
import { useSelector } from "react-redux";
import { roles } from "../../Utils/constants";
import Swal from "sweetalert2";

export default function Client() {
  const { value: isLoggedIn, role } = useSelector((state) => state.user);
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <div className="text-white text-2xl py-8 lg:px-12 sm:px-12 px-4 flex items center bg-[#2EBAA3]">
        <span>Client</span>
      </div>
      {/* Client Landing Page */}
      <div>
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="flex flex-col-reverse lg:flex-row text-center mx-4 md:mx-12"
        >
          <div className="flex flex-col space-y-10 max-w-screen-lg py-24">
            <div className="text-center lg:text-start">
              <span
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "42px",
                  lineHeight: "55px",
                }}
              >
                ProLegion for Clients
              </span>
            </div>
            <div
              className="text-center font-extralight font-[Roboto] lg:text-justify"
              style={{
                fontSize: "20px",
                lineHeight: "27px",
              }}
            >
              Prolegion provides a consolidated platform for clients to manage
              vendors, jobs, projects, timesheets, and bills. Customers may
              simply create and manage jobs on the site, as well as hire vendors
              and consultants. Prolegion also guarantees that timesheets and
              invoices are reviewed and approved correctly, allowing clients to
              better manage their vendors.
            </div>
            <div className="flex lg:justify-start justify-center">
              <button
                className="w-[191px] h-[50px] hover:h-[53px] hover:w-[195]"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  if (isLoggedIn) {
                    if (role === roles.client) navigate("/dashboard");
                    else
                      Swal.fire(
                        "",
                        `You are already logged in as a ${role.toLowerCase()}<br>To try the client section, please logout first`,
                        "info"
                      );
                  } else navigate("/signup");
                }}
              >
                <button
                  style={{
                    border: "2px solid #139588",
                    borderRadius: "25px",
                    color: "#139588",
                  }}
                  className="w-[191px] h-[50px] hover:h-[53px] hover:w-[195] mt-[2px] shadow-md hover:shadow-lg"
                >
                  Try for free
                </button>
              </button>
            </div>
          </div>
          <div className="mt-3 lg:ml-20">
            <img
              alt="landingImage"
              className="object-contain"
              src={landingImage4}
            />
          </div>
        </div>
      </div>
      {/* How we serve */}
      <div className="font-[Roboto] text-3xl lg:text-left text-center lg:px-12 py-8">
        How We Serve You
      </div>
      <div
        style={{
          background: " #EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex font-[Roboto] flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row-reverse justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-3/5 lg:ml-10 lg:pr-40">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Manage your IT Vendors & Consultants
            </div>
            <div className="lg:ml-12 space-y-4">
              <ol className="list-decimal font-extralight text-[18px] leading-[27px] text-justify">
                <li>
                  Better communication: Our platform consolidates all of your
                  communications, making it simple to manage projects and stay
                  in the loop on progress reports.
                </li>
                <li>
                  Improved project management: Clients can use our timesheet
                  tracking and invoice management capabilities to keep track of
                  project schedules and budgets, ensuring that projects are
                  finished on time and under budget.
                </li>
                <li>
                  Reduced risk: Our platform gives clients the tools they need
                  to guarantee that their vendors and consultants are in
                  compliance, lowering the chance of legal or regulatory
                  concerns.
                </li>
              </ol>
            </div>
          </div>
          <div className="flex justify-center max-h-[400px] lg:w-2/5">
            <img alt="office" className="px-4 sm:px-0 object-contain" src={office} />
          </div>
        </div>
      </div>
      {/* Timesheet & Invoices */}
      <div
        style={{ display: "flex", justifyContent: "center" }}
        className="flex flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-7/12">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Manage Timesheets & Invoices
            </div>
            <div className="lg:mr-12 font-extralight space-y-4 lg:text-justify text-center text-[18px] leading-[27px]">
              Clients can effortlessly manage their timesheets and bills using
              our IT service platform. Clients can use our timesheet tracking
              function to track billable hours for suppliers and consultants,
              ensuring precise payment and eliminating disputes. Our invoice
              management system also allows clients to automate invoice
              processing, track payment status, and manage billing and payment
              schedules. Clients can reduce administrative expenses and save
              time on manual invoicing and payment processing procedures by
              using our platform. Customers may track project budgets and
              timetables to ensure that all bills are correctly reported and
              projects are finished on time and on budget. Overall, our
              technology streamlines timesheet and invoice management, allowing
              clients to concentrate on their primary business tasks.
            </div>
          </div>
          <div className="flex justify-center lg:w-5/12 max-h-[500px]">
            <img alt="calendar" className="px-4 sm:px-0 object-contain" src={date} />
          </div>
        </div>
      </div>
      {/* Pay vendors */}
      <div
        style={{
          background: " #EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex flex-col lg:px-[50px]"
      >
        <div className="flex lg:flex-row-reverse justify-center flex-col-reverse lg:justify-evenly pb-12 pt-8">
          <div className="space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 lg:w-3/5">
            <div
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: " 36px",
                paddingBottom: "18px",
                display: "flex",
                justifyContent: "center",
              }}
              className="md:text-left text-center"
            >
              Pay your Vendors
            </div>
            <div className="lg:ml-12 font-extralight space-y-4 lg:text-justify text-center text-[18px] leading-[27px]">
              Our IT service platform enables clients to pay their vendors in a
              simple and safe manner. Our invoice management system allows
              clients to submit invoices and manage billing and payment
              schedules. Our platform accepts a variety of payment methods,
              including wire transfers and credit card payments, allowing
              clients to select the method that is most convenient for them.
              Clients can use our platform to follow payment status and ensure
              that all payments are made on time, lowering the risk of late fees
              or penalties. Our secure payment processing system protects client
              payment information, giving you peace of mind and lowering the
              risk of fraud. Overall, our platform streamlines vendor payment
              operations, assuring timely and safe vendor payments.
            </div>
          </div>
          <div className="flex justify-center lg:w-2/5 max-h-[400px]">
            <img
              alt="security"
              className="px-4 sm:px-0 object-contain"
              src={keys}
            />
          </div>
        </div>
      </div>
      {/* Register Button */}/
      <div className="py-16">
        <div className="flex justify-center">
          <button
            onClick={() => navigate(isLoggedIn ? "/dashboard" : "/signup")}
            style={{
              width: "191px",
              height: "50px",
              background: "#139588",
              borderRadius: "25px",
              color: "white",
            }}
          >
            Register
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
